



















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Resource } from '@/shared/interfaces/resource'
import PhotoSwipe from 'photoswipe'
import RespondecoImage from '@/shared/components/respondeco-image.vue'
import RespondecoBackgroundImage from '@/shared/components/respondeco-background-image.vue'
import ResourceItem from '@/business/resource/components/resource-item.vue'
import RespondecoResourceGallery from '@/shared/components/respondeco-resource-gallery.vue'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import { imageUrl } from '@/shared/utils/images'
import RespondecoGalleryItem from '@/shared/components/respondeco-gallery-item.vue'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'

@Component({
  components: {
    RespondecoResponsiveImage,
    RespondecoGalleryItem,
    RespondecoResourceGallery,
    ResourceItem,
    RespondecoBackgroundImage,
    RespondecoImage,
  },
  data() {
    return {
      instance: undefined,
    }
  },
})
export default class PhotoSwipeGallery extends Vue {
  @Prop({
    required: true,
    type: Array,
  })
  public readonly items!: Resource[]

  public openPhotoSwipe(index: number) {
    const items = this.mapImagesToItems()

    const instance = new PhotoSwipe<PhotoSwipe.Options>(
      this.$refs.photoswipe as HTMLElement,
      PhotoSwipeUI_Default,
      items,
      {
        getThumbBoundsFn: (index: number) => {
          const imageReferences = this.domImageReferences()

          return imageReferences[index]
        },
        index,
        showHideOpacity: true,
      }
    )

    document.body.classList.add('overflow-hidden')

    instance.listen('close', function() {
      document.body.classList.remove('overflow-hidden')
    })

    instance.init()
  }

  private domImageReferences(): { w: number; x: number; y: number }[] {
    const refs = this.$refs.image as Vue[]

    return refs.map(ref => {
      const el = ref.$el as HTMLElement
      const rect = el.getBoundingClientRect()
      const pageYScroll = window.pageYOffset || document.documentElement.scrollTop

      return {
        w: rect.width,
        x: rect.left,
        y: rect.top + pageYScroll,
      }
    })
  }

  private mapImagesToItems() {
    const images = this.$refs.image as Vue[]
    const items: {
      h: number
      msrc: string
      src: string
      w: number
    }[] = []

    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i]
      const image = images[i].$el as HTMLImageElement

      const height = image.height
      const width = image.width
      const aspectRatio = height / width

      items.push({
        h: 1080,
        msrc: imageUrl(item.location, 530),
        src: imageUrl(item.location, 1920),
        w: 1080 / aspectRatio,
      })
    }

    return items
  }
}
